import { useState } from 'react';
import { Alert, TextField, ThemeProvider, Button } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../../redux/Apis/Auth';
import { authErrorMessage, normalizeSession, safeReturnPath } from '../../utils/authSession';
import { StandardInputTheme } from './StandardInputTheme';
import './style.css';
export default function LoginForm({ destination = '/account' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [login, { isLoading }] = useLoginMutation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [unverified, setUnverified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    if (isLoading) return;
    setError(''); setUnverified(false);
    try {
      const response = await login({ email: email.trim().toLowerCase(), password }).unwrap();
      if (!normalizeSession(response).isLoggedIn) throw new Error('Invalid session');
      setPassword('');
      navigate(safeReturnPath(location.state?.from, destination), { replace: true });
    } catch (failure) {
      setError(authErrorMessage(failure, 'Inloggningen kunde inte slutföras. Kontrollera dina uppgifter och försök igen.'));
      setUnverified(failure?.data?.code === 'EMAIL_NOT_VERIFIED');
    }
  };
  return <ThemeProvider theme={StandardInputTheme}><div className="login-form-container shadow">
    <form onSubmit={submit}>
      <h2 className="loginpage_heading">Logga in</h2>
      <TextField fullWidth margin="normal" label="E-postadress" type="email" autoComplete="username" required value={email} onChange={(event) => setEmail(event.target.value)} disabled={isLoading} />
      <TextField fullWidth margin="normal" label="Lösenord" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} disabled={isLoading} />
      <Button type="button" onClick={() => setShowPassword(!showPassword)}>{showPassword ? 'Dölj lösenord' : 'Visa lösenord'}</Button>
      {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
      {unverified && <Link to="/verify-email" state={{ email }}>Skicka en ny verifieringslänk</Link>}
      <div className="my-3"><Link to="/forgot-password">Glömt lösenord?</Link></div>
      <button type="submit" className="btn btn-login" disabled={isLoading}>{isLoading ? 'Loggar in…' : 'Logga in'}</button>
      <p className="mt-3">Saknar du konto? <Link to="/auth/register">Skapa konto</Link></p>
    </form>
  </div></ThemeProvider>;
}
